import React from "react";
import {Redirect} from "react-router-dom";
import {useAnalytics} from "@unibuddy/tracking";
import {
    useLocalStorage
} from "@unibuddy/patron";
import {Routes} from "ubcommunity-shared/src/constants/routes";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";
import{
    PageTitles,
    TrackEvents
} from "ubcommunity-shared/src/constants";
import useSSOAuthCode from "../hooks/useSSOAuthCode"
import useMeQuery from "../hooks/useMeQuery"
import ActivityIndicator from "ubcommunity-shared/src/General/ActivityIndicator/ActivityIndicator";
import {BackButton} from "../../Layout/BackButton/BackButton";
import {LoginHeader} from "../../Layout/Header/LoginHeader";
import AuthPage from "../AuthPage/AuthPage";
import ErrorMessage from "../ErrorMessage/ErrorMessage";

export default function SSOLogin() {
    const {accessToken, error: codeError} = useSSOAuthCode();
    const {me, error: meError} = useMeQuery(accessToken);
    const {trackEvent} = useAnalytics();
    const [inviteId] = useLocalStorage("community-invite-id.v1");
    usePageTitle(PageTitles.SSO_LOGIN);

    if (codeError || meError) {
        return (
            <AuthPage
                title={<LoginHeader title="Back" />}
                headerLeftButton={<BackButton to={Routes.BASE_AUTH} />}>
                <ErrorMessage message={codeError || meError} />
            </AuthPage>
        );
    }

    trackEvent(TrackEvents.PROSPECT_LOGGED_IN);

    // if user came from invite flow send them back to the invite page
    if (inviteId && me.anyUser.verified) {
        return <Redirect to={`/invite/${inviteId}`} />
    } else {
        // if user came from SSO flow send them back to the university page
        if (accessToken && me) {
            return <Redirect to={`/u/${me.anyUser.university.slug}/landing`} />
        }
    }

    return (
        <AuthPage
            title={<LoginHeader title="Back" />}
            headerLeftButton={<BackButton to={Routes.BASE_AUTH} />}>
            <ActivityIndicator accessibilityLabel="Loading user..." />
        </AuthPage>
    );
}
